import { QueryHookOptions } from '@apollo/client';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';
import gql from 'graphql-tag';
import { ContentTaskFilteringGq } from '../../models/ContentTaskFilteringGq';
import { ContentTaskGq, ContentTaskGqProps } from '../../models/ContentTaskGq';
import { ContentTaskSortingGq } from './../../models/ContentTaskSortingGq';

export function useGetContentTasksGq(
  command: CommandGq,
  options?: QueryHookOptions<DataGq, VariablesGq>
) {
  const query = useCustomQuery<DataGq, VariablesGq>(gqTag, {
    variables: { command },
    fetchPolicy: 'cache-and-network',
    ...options,
  });

  return {
    query,
    contentTasks: (query?.data ?? query?.previousData)?.projects?.getContentTasks?.contentTasks,
    count: (query?.data ?? query?.previousData)?.projects?.getContentTasks?.count,
    rowsPerPage: (query?.data ?? query?.previousData)?.projects?.getContentTasks?.rowsPerPage,
    page: (query?.data ?? query?.previousData)?.projects?.getContentTasks?.page,
  };
}

export const gqTag = gql`
  query GetContentTasks($command: GetContentTasksCommand!) {
    projects {
      getContentTasks(command: $command) {
        contentTasks { ${ContentTaskGqProps} }
        count
        page
        rowsPerPage
      }
    }
  }
`;

export interface DataGq {
  readonly projects: {
    readonly getContentTasks: {
      readonly contentTasks: ContentTaskGq[];
      readonly count: number;
      readonly page: number;
      readonly rowsPerPage: number;
    };
  };
}

export interface VariablesGq {
  command: CommandGq;
}

export interface CommandGq {
  rowsPerPage: number;
  page: number;
  filtering: ContentTaskFilteringGq;
  sorting: ContentTaskSortingGq;
}
